var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgYoutube = function SvgYoutube(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 14.41c1.65-.86 3.29-1.7 4.94-2.57L10 9.26v5.13ZM12 1a11 11 0 1 0 .01 22.01A11 11 0 0 0 12 1m7.49 14.67c-.2.83-.87 1.43-1.67 1.53-1.93.22-3.87.22-5.82.22s-3.89 0-5.82-.22a1.94 1.94 0 0 1-1.67-1.53c-.27-1.17-.27-2.46-.27-3.67s0-2.49.27-3.67c.18-.83.87-1.43 1.67-1.53 1.93-.22 3.87-.22 5.82-.22s3.89 0 5.82.22c.81.09 1.49.7 1.67 1.53.27 1.17.27 2.46.27 3.67s0 2.49-.27 3.67"
  })));
};
export { SvgYoutube as ReactComponent };
export default __webpack_public_path__ + "static/media/youtube.86a4825de1aa7bf355c4847a180ca03f.svg";